require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./projecten-zwaluwenbunders.json") })
        }
      }, "path---projecten-zwaluwenbunders");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---projecten-zwaluwenbunders!./.cache/json/projecten-zwaluwenbunders.json
// module id = 459
// module chunks = 231608221292675